
    import React from 'react'
    const rootRoute = { childRoutes: [
      {
        path:'/blog/',
        component: require('/opt/build/repo/layouts/default'),
        indexRoute: 
      {
        
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/pages/blog/index.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/blog.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---blog')
          }, 'page-component---pages-blog-index-js')
        }
      },
    
        childRoutes: [
      
      {
        path:'/blog/01-03-2017-Three+Reasons+Why+Speed+Is+Top+Priority/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/page-templates/blog-detail.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/blog-01-03-2017-three-reasons-why-speed-is-top-priority.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---blog-01-03-2017-three-reasons-why-speed-is-top-priority')
          }, 'page-component---page-templates-blog-detail-js')
        }
      },
    
      {
        path:'/blog/01-02-2017-Our+Favorite+Design+Products/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/page-templates/blog-detail.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/blog-01-02-2017-our-favorite-design-products.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---blog-01-02-2017-our-favorite-design-products')
          }, 'page-component---page-templates-blog-detail-js')
        }
      },
    
      {
        path:'/blog/01-01-2017-Introducing-Krasa--Mobile-App-Web-Design-Development/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/page-templates/blog-detail.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/blog-01-01-2017-introducing-krasa-mobile-app-web-design-development.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---blog-01-01-2017-introducing-krasa-mobile-app-web-design-development')
          }, 'page-component---page-templates-blog-detail-js')
        }
      },
    
      {
        path:'/blog/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/pages/blog/index.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/blog.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---blog')
          }, 'page-component---pages-blog-index-js')
        }
      },
    
      {
        path:'/',
        getComponent (nextState, cb) {
          require.ensure([], (require) => {
            let Component = require('/opt/build/repo/pages/index.js')
            if (Component.default) {
              Component = Component.default
            }
            require.ensure([], (require) => {
              const data = require('./json/index.json')
              cb(null, () => <Component {...nextState} {...data} />)
            }, 'path---index')
          }, 'page-component---pages-index-js')
        }
      },
    ]},]}
    module.exports = rootRoute


// WEBPACK FOOTER //
// ./.intermediate-representation/split-child-routes.js